/**
 * EQ-28: the one label for the Type field (On-Road / Off-Road), which drives the fuel surcharge.
 * Stored spellings vary ("On-road", "ON_ROAD", "On Road"); every screen shows exactly these two.
 */
export const ROAD_TYPES = ['On-Road', 'Off-Road'] as const;
export type RoadType = (typeof ROAD_TYPES)[number];

/** 'On-Road' / 'Off-Road' for any stored spelling, else null (unknown or empty). */
export function roadTypeLabel(value?: string | null): RoadType | null {
  if (!value) return null;
  const key = String(value).trim().toLowerCase().replace(/[\s_-]+/g, '');
  if (key === 'onroad') return 'On-Road';
  if (key === 'offroad') return 'Off-Road';
  return null;
}

/** A unit's Type: `vehicleType` first, then the parallel fuel `roadClass` (ON_ROAD / OFF_ROAD). */
export function unitRoadTypeLabel(unit: { vehicleType?: string | null; roadClass?: string | null }): RoadType | null {
  return roadTypeLabel(unit.vehicleType) ?? roadTypeLabel(unit.roadClass);
}
